import { mapActions, mapGetters, mapMutations } from 'vuex'
import { EventBus } from '@/event-bus.js'
import { BroadcastChannel } from 'broadcast-channel'

export default {
  computed: {
    ...mapGetters('notifications', [
      'fcmSupport',
      'unreadNotifications'
    ]),
    showRequestPermissionAlert () {
      if ('Notification' in window && this.fcmSupport) {
        return process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes' && Notification.permission === 'default'
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapActions('notifications', [
      'requestPermission',
      'initializeNotifications',
      'getNotifications',
      'checkBrowserSupportFirebaseMessagin'
    ]),
    ...mapMutations('notifications', [
      'mutateClearUnreadNotifications'
    ]),
    hasUnreadNotifications (count) {
      if (!count) {
        document.title = this.title
        document.getElementById('favicon').href = this.favicon
        const channel = new BroadcastChannel('clearNotifications')
        channel.postMessage(true)
      } else {
        document.title = `(${this.unreadNotifications}) ${this.title}`
        document.getElementById('favicon').href = this.faviconDot
      }
    },
    // Inicia las notificaciones
    async notificationsInit () {
      this.checkBrowserSupportFirebaseMessagin()
      this.initializeNotifications()
      await this.getNotifications()

      if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
        this.sockets.subscribe('notificationsUpdated', async _ => {
          await this.getNotifications()
        })
      }

      // Listener de notificaciones push
      EventBus.$on('onMessage', data => {
        document.getElementById('favicon').href = this.faviconDot

        const pushContext = data?.data?.data || false

        if (pushContext) {
          this.lmNotificationSuccessMessage({
            message: data.notification.title,
            description: data.notification.body,
            context: JSON.parse(pushContext)
          })
        } else {
          this.lmToastSuccessPushNotification(data.notification.click_action, data.notification.title, data.notification.icon, data.notification.body)
        }

        if (!process?.env?.VUE_APP_SOCKET_ENABLED === 'yes') {
          setTimeout(async _ => {
            await this.getNotifications()
          }, 1000)
        }
      })

      // Escuchamos por notificaciones en segundo plano
      // Si le hacemos click, redireccionamos a "click_action"
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.onmessage = event => {
          if (event.data.messageType === 'notification-clicked') {
            if (event?.data?.notification?.click_action) {
              const clickAction = event.data.notification.click_action
              const url = new URL(clickAction)
              const to = url.pathname
              this.$router.push(to)
            }
          }
        }
      }

      const channel = new BroadcastChannel('clearNotifications')
      channel.onmessage = event => {
        if (event) {
          this.mutateClearUnreadNotifications()
        }
      }
    }
  },

  watch: {
    unreadNotifications (val) {
      this.hasUnreadNotifications(val)
    }
  }
}
